import React from "react";
import PropTypes from "prop-types";

import "./input.scss";

const Input = ({
  placeholder,
  label,
  name,
  type,
  errors,
  isValidChange,
  value,
  onChange,
  touched,
  ...optionalProps
}) => {
  return (
    <div className="mb-2">
      <label for={name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <input
        className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500' ${
         touched &&  errors.length > 0 ? "border-red-500" : ""
        }`}
        id={name}
        type={type}
        onChange={(e) => isValidChange(e.target.value, e) && onChange(e.target.value, e)}
        placeholder={placeholder}
        value={value}
        {...optionalProps}
      />
      {errors?.length > 0 && touched && (
        <p className="text-red-500 text-xs italic">{errors}</p>
      )}
    </div>
  );
};

Input.defaultProps = {
  type: "text",
  required: false,
  value: "",
  touched: false,
  errors: [],
  placeholder: " ",
  isValidChange: (value) => true,
};

Input.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  touched: PropTypes.bool,
  isValidChange: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
};

export default Input;
